import React from 'react'
import styled from '@emotion/styled'
import GeneralModal from './GeneralModal'
import Button from '../../generic/button'

export default ({ onClick, children, informational, buttonOverride = false, testId, ...props }) => {
  return (
    <div>
      <GeneralModal {...props} testid={testId}>
        {children}
        <div>
          <DoneButton data-testid={ `btn-${testId? testId:''}-done`} onClick={onClick}>{buttonOverride ? buttonOverride : informational ? 'Close' : 'Done'}</DoneButton>
        </div>
      </GeneralModal>
    </div>
  )
}

const DoneButton = styled(Button)`
  margin-top: 16px;
`
